export default "__VITE_ASSET__CLChLmfl__"